// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"a1600078","990":"76b35ccb"}[chunkId] + ".chunk.css";
};